import { ReactKeycloakProvider } from "@react-keycloak/web";
import React from "react";
import { JL } from "jsnlog";
import Keycloak from "keycloak-js";
import Cookies from "universal-cookie";

import RouteComponents from "../routes";

const Authenticate = (props) => {
  const initOptions = {
    onLoad: "login-required",
    checkLoginIframe: false,
  };

  const eventLogger = (event, error) => {
    const cookies = new Cookies();
    if (event === "onAuthSuccess") {
      cookies.set("sso_login", true, { path: "/" });
      JL.setOptions({
        /* eslint-disable */
        defaultAjaxUrl: `${environmentConfig.ADMIN.apiHost}/jsnlog.logger`,
        /* eslint-enable */
        defaultBeforeSend: (xhr) => {
          // ToDo: need to revisit after swr completion
          // const orgId = getCurrentCompanyId();
          // if (orgId) {
          //   xhr.setRequestHeader("JSNLog-RequestId", orgId);
          // }
        },
      });

      // define a new console for jsnlog
      const console = ((oldCons) => {
        return {
          debug: function (...msg) {
            oldCons.debug(...msg);
            JL(`client`).debug(...msg);
          },
          error: function (...msg) {
            console.log("Debugging msg:", ...msg);
            if (oldCons?.error) {
              oldCons.error(...msg);
            } else {
              JL(`client`).error("Console error method is unavailable", ...msg);
            }
            console.log("Debugging console:", window.console);
            oldCons.error(...msg);
            JL(`client`).error(...msg);
          },
          info: function (...msg) {
            oldCons.info(...msg);
            JL(`client`).info(...msg);
          },
          log: function (...msg) {
            oldCons.log(...msg);
            JL(`client`).log(...msg);
          },
          table: function (...msg) {
            oldCons.table(...msg);
            JL(`client`).log(...msg);
          },
          warn: function (...msg) {
            oldCons.warn(...msg);
            JL(`client`).warn(...msg);
          },
        };
      })(window.console);
      window.console = console;

      var ajaxAppender = JL.createAjaxAppender("ajaxAppender");
      var consoleAppender = JL.createConsoleAppender("consoleAppender");
      JL(`client`).setOptions({ appenders: [ajaxAppender, consoleAppender] });
    }
  };

  const tokenLogger = (tokens) => {
    localStorage.setItem("qjumpers.publicui.auth.token", tokens.token);
  };

  return (
    <ReactKeycloakProvider
      onEvent={eventLogger}
      onTokens={tokenLogger}
      initOptions={initOptions}
      authClient={new Keycloak(props.data)}>
      <RouteComponents />
    </ReactKeycloakProvider>
  );
};

export default Authenticate;
